import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
    createStyles({
        rtwCheckboxLabel: {
            color: '#4D575E',
            alignItems: 'center',
            marginLeft: 0,
            marginBottom: theme.spacing(1),
            '& .MuiCheckbox-root': {
                padding: 6,
            },
            '& .MuiFormControlLabel-label': {
                fontSize: 14,
                lineHeight: 1.4,
            },
        },
    }),
);
